<div class="coupon-form-container" *transloco="let t;">
        <div class="header-wrapper">
        <span class="form-title">{{t('modals.add_coupon_modal.title')}}</span>
        <button class="button-undecorated close-button" [attr.aria-label]="t('modals.add_coupon_modal.close_modal')" (click)="closeModal()">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>
    <div class="coupon-form-wrapper" #couponFormContainer>
        @if(isTempApplied) {
            <div class="error-wrapper">
                <cwo-icon class="error-icon" [name]="iconNameType.error"></cwo-icon>
                <div class="text-group">
                    <span class="error-text">{{t('modals.add_coupon_modal.pending_message')}}</span>
                    <button class="order-details-button" (click)="toggleOrderDetails()">
                        <span class="order-details-text">{{t('modals.add_coupon_modal.order_details')}}</span>
                        <cwo-icon class="arrow-icon" [name]="iconNameType.arrow" [size]="'0.875rem'"/>
                    </button>
                </div>
            </div>
        }
        @if(allErrors?.length){
        <div class="generic-errors">
            @for (error of allErrors; track $index) {
                @if (error) {
                    <span class="error"><cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>{{!error.trim().endsWith('.') ? error + ('.') : error}}</span>
                }
            }
        </div>
        }

        @if (coupons().length > 0) {
            @if (availableCoupons().length > 0) {
                <div class="coupons-container">
                    <span class="coupon-header">{{t('modals.add_coupon_modal.available_coupons')}}</span>
                    <div class="coupons-group">
                        @for (coupon of availableCoupons(); track $index; let index = $index) {
                            <cwo-coupon-detail [index]="index" [isSelected]="isCouponSelected(coupon, index)" [anotherCouponLoading]="loadingCouponIndex !== -1" [loading]="loadingCouponIndex === index" [coupon]="coupon"  (couponSelected)="handleSelectCoupon($event, coupon, index)" />
                        }
                    </div>
                </div>
            }

            @if (unavailableCoupons().length > 0) {
                <div class="coupons-container">
                    <span class="coupon-header unailable">{{t('modals.add_coupon_modal.unavailable_coupons')}}</span>
                    <div class="coupons-group">
                        @for (coupon of unavailableCoupons(); track $index; let index = $index) {
                        <cwo-coupon-detail [index]="index" [coupon]="coupon" [loading]="false" />
                        }
                    </div>
                </div>
            }
        }

        @else {
        <div class="no-coupon-wrapper">
            <img [src]="'assets/icons/no-coupon-card.svg' | deployUrl" [alt]="'No Coupon Card'" class="no-coupon-card-image">
            @if (accountState()?.signUpForLoyalty) {
                <span class="no-coupon-text">{{t('modals.add_coupon_modal.no_coupon_with_loyalty')}}</span>
            }

            @else {
                <span class="no-coupon-text">{{t('modals.add_coupon_modal.no_coupon_without_loyalty')}}</span>
            }
        </div>
        }
    </div>
    <div class="coupon-input-with-errors">
        <div class="coupon-input-wrapper">
            <span class="coupon-input-header">{{t('modals.add_coupon_modal.apply_coupon_code_label')}}</span>
            <cwo-coupon-input #couponInputField [disabled]="loadingCouponIndex !== -1" (formSubmitted)="handleApplyCoupon($event)" />
        </div>
        @if (couponInputErrors?.length) {
        <div class="coupon-input-errors" [@openClose] role="alert" [attr.aria-live]="'assertive'" aria-atomic="true">
            @for (error of couponInputErrors; track $index) {
                @if (error) {
                <span class="input-error">
                    <cwo-icon aria-hidden="true" class="icon" [name]="iconNameType.error"></cwo-icon>
                    {{ !error.trim().endsWith('.') ? error + '.' : error }}
                </span>
                }
            }
        </div>
        }

        @if (couponWarningApplicationFailed && couponResponse) {
          <div class="warnings-wrapper">
            <cwo-order-warning [warning]="couponWarningApplicationFailed" (instructionButtonClicked)="handleInstruction()" borderRadius="8px"/>
          </div>
        }
    </div>
</div>

<ng-template #couponInstructionModal>
  <div class="instruction-modal-container" *transloco="let t">
    <span class="special-name"> {{couponResponse?.name}} </span>
    <span class="modal-title">{{t('modals.cart.how_to_apply')}}</span>
    <span class="modal-text">{{ couponResponse?.instructions }}</span>
  </div>
</ng-template>

<ng-template #couponWarningModal>
  <cwo-coupon-conflict [couponWarning]="couponWarning"></cwo-coupon-conflict>
</ng-template>
